export const PAYTYPE_IPAY = 'PAYTYPE_IPAY';
export const PAYTYPE_FRIENDPAY = 'PAYTYPE_FRIENDPAY';